'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;
// import numeral from 'numeral';


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _components = require('components');

var _support = require('helpers/support');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import { Link } from 'react-router';
// import { getColorRatingCode, getAvatar, renderTime, getUrlImage } from 'helpers/lib';
var ServiceList = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(ServiceList, _Component);

  function ServiceList() {
    (0, _classCallCheck3.default)(this, ServiceList);
    return (0, _possibleConstructorReturn3.default)(this, (ServiceList.__proto__ || (0, _getPrototypeOf2.default)(ServiceList)).apply(this, arguments));
  }

  (0, _createClass3.default)(ServiceList, [{
    key: 'renderService',
    value: function renderService(services) {
      var _this2 = this;

      return services.map(function (service, i) {
        // let index = '';
        var border = true;
        if (i === services.length - 1) {
          border = false;
          // if (last) {
          //   index = 'last';
          // }
        }
        var data = {
          primary: service.name,
          extra: _support.Helper.formatMoney(service.price),
          item: service
        };
        return _react2.default.createElement(_components.StepButton, {
          bookingEnabled: _this2.props.shop && _this2.props.shop.isBooking,
          data: data,
          onClick: function onClick(item) {
            return _this2.props.onChange('service', item);
          },
          key: service.category + '_' + i,
          border: border
        });
      });
    }
  }, {
    key: 'renderExpand',
    value: function renderExpand() {
      var _this3 = this;

      var services = this.props.services;

      if (services) {
        return services.map(function (item, i) {
          var show = false;
          // let index = '';
          if (i === 0) {
            // index = 'first';
            show = true;
          }
          if (i === services.length - 1) {
            // index = 'last';
          }
          if (services.length === 1) {
            // index = 'one';
          }
          var object = {
            titleLeft: item.category.label,
            titleRight: item.numberService + ' d\u1ECBch v\u1EE5',
            show: show,
            key: 'expand_' + i
          };
          return _react2.default.createElement(
            _components.Expand,
            object,
            _this3.renderService(item.services, i === services.length - 1)
          );
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var styles = require('./ServiceList.scss');
      return _react2.default.createElement(
        'div',
        { className: styles.serviceDetail },
        _react2.default.createElement(
          'div',
          { className: styles.head },
          _react2.default.createElement(
            'label',
            null,
            'D\u1ECBch v\u1EE5'
          )
        ),
        this.renderExpand()
      );
    }
  }]);
  return ServiceList;
}(_react.Component), _class.propTypes = {
  shop: _react.PropTypes.object,
  services: _react.PropTypes.array,
  // @action
  onChange: _react.PropTypes.func
}, _temp);
exports.default = ServiceList;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Mobile/Detail/ServiceList.js
// module id = 1592
// module chunks = 0